import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HorizontalAlignmentOptions, RatioOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NewsletterFormComponent } from '../../../../../newsletter/newsletter-form.component';

export interface ISubscribeNewsletterData extends NICmsContentComponent.IData {
    title?: string;
    topCopy?: string;
    bottomCopy?: string;
    text_align?: string;
    bg_color?: string;
    cta_copy?: string;
    ratio?: string;
}
@ICmsComponent<PageComponentSubscribeNewsletterComponent>({
    id: 'subscribe-newsletter',
    name: 'Subscribe newsletter block',
    tags: ['newsletter'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            default: 'Sign up to our newsletter'
        },
        <NICmsContentField.IField>{
            key: 'topCopy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Top copy'
        },
        <NICmsContentField.IField>{
            key: 'bottomCopy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Bottom copy'
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Alignment',
            options: HorizontalAlignmentOptions,
            default: 'center'
        },
        <NICmsContentField.IField>{
            key: 'cta_copy',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA copy',
            default: 'Sign up'
        },
        <NICmsContentField.IField>{
            key: 'bg_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Background Color'
        }
    ]
})
@Component({
    selector: 'page-component-subscribe-newsletter',
    templateUrl: 'subscribe-newsletter.component.html',
    standalone: true,
    imports: [CommonModule, ICmsClientModule, NewsletterFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentSubscribeNewsletterComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: ISubscribeNewsletterData;
}
